module.exports = __webpack_public_path__ + "img/winfield-bg.10ab51f8.png";